import { createSelector } from '@reduxjs/toolkit'

import { getPracticesState } from './practicesSelectors'

export const getPracticesData = createSelector(getPracticesState, (practicesState) => practicesState.data)

export const getPracticesDataPracticesList = createSelector(getPracticesData, (dataState) => dataState.practicesList)

export const getPracticesDataAvailablePractices = createSelector(
  getPracticesData,
  (dataState) => dataState.availablePractices,
)

export const getPracticesDataIsLoadingAvailablePractices = createSelector(
  getPracticesData,
  (dataState) => dataState.isLoadingAvailablePractices,
)
